const guidRegex = new RegExp(
  '^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
  'i',
);

export function isGuid(value: string | null | undefined): value is string {
  if (typeof value !== 'string') return false;
  return guidRegex.test(value);
}
